import { camelCase } from 'lodash';
import { useMemo } from 'react';
import { filterableFieldType } from 'components/organisms/tasks/fields';
import { useProjectCustomFields } from './use-project-fields';
export const useProjectCustomFieldsAsFilterableFields = ()=>{
    const { data: projectCustomFields, isLoading: isProjectCustomFieldsLoading } = useProjectCustomFields();
    return useMemo(()=>({
            loading: isProjectCustomFieldsLoading,
            fields: projectCustomFields.map((field)=>({
                    ...field,
                    fieldName: camelCase(field.fieldName),
                    type: filterableFieldType(field)
                })).filter((field)=>field.isEnabled)
        }), [
        isProjectCustomFieldsLoading,
        projectCustomFields
    ]);
};
